module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAsCAMAAACjdTNyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF5+jo0ebd9Pb0+/z8yNPNztDQ2+zky9rT6fHs1NXV1ungz+LZ2+De0d7X////3u7pDNqu4QAAAPxJREFUeNp0lEcSxSAMQw0mFNPuf9uPSfkU40UWeSMjiUyg8Hivyz7Qn1SJqheZpsqj7CzvzNd3Jnlnto7zyZkh1WVuOUwrJ7mGbeWnRWZKZJF18srqWCejmtkLySw1pmWmoLHDyqgbO6x0LTvSyUqBw3E2sc7JVrhPvMRasuauwRysNIYhy1a4F33tdgieu01OSv7c+27H4fu9gLHCcTfD4I5ss0PwZ6udbuVlGOJm5WWLnVxGNm9NM9NDSAUzK8ksVgY2dO7Kwor/QuaNfXZs2tnduYrR76yHpOsyWmClda5CCEViLaRCBJG1kGr9vwwhzZG1rWc2vvgJMAC3jj3JmvhL4AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/NV.png
// module id = /AEk
// module chunks = 1